import StarLoader from './starLoader'
import CoverLoader from './coverLoader'

export { StarLoader, CoverLoader }
